import {Money} from "../../core/models/money";
import {Address} from "../../core/models/address";

export abstract class Payment {
  fullName: string;
  amount: Money;
  billingAddress: Address;
  type:string;
}
